import { useAuth } from "@shared/features/auth/hooks/useAuth";

export const useSession = () => {
  const auth = useAuth();

  if (!auth.session || !auth.user) {
    return {
      session: null,
      isImpersonating: false,
      isAdmin: false,
      isCurrentUserAdmin: false,
    };
  }

  return {
    session: auth.session,
    isImpersonating: auth.session?.isImpersonation,
    isAdmin: auth.session.isAdmin,
    isCurrentUserAdmin: auth.session.isCurrentUserAdmin,
  };
};
